"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
function waitForNext(criteria) {
    return function (observable) {
        return observable.pipe(operators_1.filter(function (value) { return valueMeetsCriteria(value, criteria); }), operators_1.take(1));
    };
}
exports.waitForNext = waitForNext;
function valueMeetsCriteria(value, criteria) {
    if (!criteria)
        return !!value;
    else
        return criteria(value);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2FpdC1mb3ItbmV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vcGVyYXRvcnMvd2FpdC1mb3ItbmV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLDRDQUE0QztBQUc1QyxTQUFnQixXQUFXLENBQUksUUFBMkI7SUFDdEQsT0FBTyxVQUFBLFVBQVU7UUFDYixPQUFPLFVBQVUsQ0FBQyxJQUFJLENBQ2xCLGtCQUFNLENBQUksVUFBQSxLQUFLLElBQUksT0FBQSxrQkFBa0IsQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLEVBQW5DLENBQW1DLENBQUMsRUFDdkQsZ0JBQUksQ0FBSSxDQUFDLENBQUMsQ0FDYixDQUFDO0lBQ04sQ0FBQyxDQUFDO0FBQ04sQ0FBQztBQVBELGtDQU9DO0FBRUQsU0FBUyxrQkFBa0IsQ0FBSSxLQUFRLEVBQUUsUUFBMkI7SUFDaEUsSUFBSSxDQUFDLFFBQVE7UUFBRSxPQUFPLENBQUMsQ0FBQyxLQUFLLENBQUM7O1FBQ3pCLE9BQU8sUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ2hDLENBQUMifQ==